import { render, staticRenderFns } from "./jpointSettingAdd.vue?vue&type=template&id=b29f92c4&scoped=true"
import script from "./jpointSettingAdd.vue?vue&type=script&lang=js"
export * from "./jpointSettingAdd.vue?vue&type=script&lang=js"
import style0 from "./jpointSettingAdd.vue?vue&type=style&index=0&id=b29f92c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29f92c4",
  null
  
)

export default component.exports